import React from 'react'
import { Link } from 'react-router-dom'
import './Styles/Details.css'
import { createBrowserHistory, History } from 'history' 

export default function Details() {

    const history = createBrowserHistory()
    const events = ['PAPER PRESENTATION', 'CODING CHALLENGER', 'CYBER HOLMES', 'EUREKA TIMING', 'PICTOMANIA', 'SKETCH IT', 'ADVERTISEMENT', 'CONNEXION']
    
    return (
        <div className='detailhome'>
            <div className='conteiner'>
            <div className='card'>
                <div className='cardd'>
                    <div className='expt'>List of Events</div>
                    <div className='expd'>Here is all the events happening this year. For team based events, individual registrations are enough. <span className='spand'>No</span> registration fee. Rules are attached along with the registration form.</div>
                </div>
            </div>
            <div className='card'>
                <div className='listd'>
                    <div className='listb'>
                        {
                            events.map(item=>{
                                return <div className='ecard'><Link to={'/about/'+item} style={{textDecoration: 'none', color: 'white'}}>{item}</Link></div>
                            })
                        }
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}
